import getAssetName from '../utils/getAssetName'

const loadedComponents = {}

export function registerComponents(requireContext, context) {
  const componentFiles = requireContext.keys()

  return componentFiles.map((file) => {
    const name = getAssetName(file)
    let component = requireContext(file)
    loadedComponents[name] = component

    // Unwrap "default" from ES6 module
    component = component.default || component

    if (typeof component === 'function') {
      component = component.call(null, context)
      context.vueApp.component(name, component)
    } else if (typeof component === 'object' && typeof component.install === 'function') {
      context.vueApp.use(component, context)
    } else {
      context.vueApp.component(name, component)
    }

    // Return the registered component
    return { name, component }
  })
}

export async function importComponent(name, component) {
  if (name in loadedComponents) {
    return loadedComponents[name]
  } else if (component) {
    loadedComponents[name] = await component
    return loadedComponents[name]
  }
}

export default function loadComponents(vueApp, context) {
  const requireContext = require.context(
    // root folder for components
    './',
    // recursive
    true,
    // include all .js wo index.js
    /\/(?!index\.js$)(?:[^.]+)\.(js|vue)$/
  )

  return registerComponents(requireContext, context)
}
